<template>
    <div class="business">
        <div class="business-top">
            <span class="business-top-title mg-r-10">业务开通</span>
            <el-select v-model="tenantId" placeholder="选择开通企业" size="mini" @change="changeTenant" filterable clearable>
                <el-option v-for="(item, index) in tenantList" :key="index" :value="item.id" :label="item.name"></el-option>
            </el-select>
        </div>
        <div class="business-body">
            <el-empty description="请选择企业查询" v-if="data.length === 0"></el-empty>
            <el-row :gutter="20" v-else>
                <template v-for="(item, index) in data">
                    <el-col :span="4" :key="index" style="min-width: 300px">
                        <el-card class="business-body-card">
                            <div class="business-body-card-body">
                                <div class="business-body-card-body-img">{{ item.name.slice(0, 2) }}</div>
                                <div>
                                    <div class="business-body-card-body-name">
                                        <span class="mg-r-10">{{ item.name }}</span>
                                        <el-tag :type="item.isOpen ? 'success' : ''" size="small">
                                            {{ item.isOpen ? '已开通' : '未开通' }}
                                        </el-tag>
                                    </div>
                                    <el-button size="mini" type="primary" @click="open(item)" v-if="!item.isOpen"
                                        :loading="item.loading">
                                        开通
                                    </el-button>
                                    <el-button size="mini" type="danger" @click="close(item)" v-if="item.isOpen"
                                        :loading="item.loading">
                                        关闭
                                    </el-button>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </template>
            </el-row>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            data: [],
            tenantId: null,
            tenantList: [],
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.$axios.get(`/account/tenant/all`).then(res => {
                this.tenantList = res.data.data
            })
        },
        changeTenant() {
            if (this.tenantId) {
                this.data = [
                    { code: 'digitalMarketing', name: '数字运销', loading: false },
                    { code: 'wlBusiness', name: '物流总包', loading: false }
                ]
                const params = {
                    tenantId: this.tenantId
                }
                this.$axios.post('/account/internal/getTenantBusiness', params).then(res => {
                    let data = res.data.data || []
                    let openCodeList = data.map((item) => { return item.code })
                    this.data.forEach(item => {
                        this.$set(item, 'isOpen', openCodeList.includes(item.code))
                    })
                }).catch(() => {
                    this.data = []
                })
            } else {
                this.data = []
            }
        },
        open(item) {
            this.$set(item, 'loading', true)
            const params = {
                code: item.code,
                tenantId: this.tenantId
            }
            this.$axios.post(`/account/internal/onTenantBusiness`, params).then(() => {
                this.$message.success(`开通${item.name}成功`)
                this.changeTenant()
            }).catch(() => {
                this.$set(item, 'loading', false)
                console.log(`开通${item.name}失败`)
            })
        },
        close(item) {
            this.$set(item, 'loading', true)
            const params = {
                code: item.code,
                tenantId: this.tenantId
            }
            this.$axios.post(`/account/internal/offTenantBusiness`, params).then(() => {
                this.$message.success(`关闭${item.name}成功`)
                this.changeTenant()
            }).catch(() => {
                this.$set(item, 'loading', false)
                console.log(`关闭${item.name}失败`)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.business {
    padding: 10px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background-color: #f8f8f9;

    .mg-r-10 {
        margin-right: 10px;
    }

    .business-top {
        padding: 10px;
        box-sizing: border-box;
        background: #f8f8f9;
        color: #606266;
        border-radius: 5px;

        .business-top-title {
            font-size: 12px;
        }
    }

    .business-body {
        height: 90%;
        overflow: auto;
        padding: 10px;
        box-sizing: border-box;

        .business-body-card {
            margin: 5px 0;

            .business-body-card-body {
                display: flex;
                justify-content: flex-start;

                .business-body-card-body-img {
                    width: 50px;
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                    background: #409eff;
                    color: #fff;
                    border-radius: 5px;
                    margin-right: 10px;
                }

                .business-body-card-body-name {
                    font-size: 14px;
                    color: #606266;
                    margin-bottom: 3px;
                }

                ::v-deep .el-button--mini {
                    padding: 5px 10px !important;
                }
            }
        }
    }
}
</style>